import * as api from "../constants/api";
import * as axiosUtils from "../utils/axiosUtils";

export const actionType = "MILJOGEBYR_KOMMENTARER";

export const getAllMiljogebyrKommentarer = (miljogebyrId) => {
  const url = api.GET_ALL_MILJOGEBYR_KOMMENTARER_URL(miljogebyrId);
  return axiosUtils.GetAll(url, actionType);
};

export const createMiljogebyrKommentar = (miljogebyrId, payload) => {
  const url = api.CREATE_MILJOGEBYR_KOMMENTAR_URL(miljogebyrId);
  return axiosUtils.Post(url, payload);
};
